export const DATASET_QUERY_LIMIT = 1000
export const FIELD_ID_ALL = 'ALL'
